import { render, staticRenderFns } from "./emailDetail.vue?vue&type=template&id=e06bf342&scoped=true&"
import script from "./emailDetail.vue?vue&type=script&lang=js&"
export * from "./emailDetail.vue?vue&type=script&lang=js&"
import style0 from "./emailDetail.vue?vue&type=style&index=0&id=e06bf342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06bf342",
  null
  
)

export default component.exports